// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"2c38a88e","777":"57767b71","796":"6b415ea3"}[chunkId] + ".css";
};